const StarRating = ({ rate }) => {
    return (
        <div className="star-rating">
            {[1, 2, 3, 4, 5].map((star) => {
                const fillPercentage = Math.min(
                    Math.max(rate - (star - 1), 0),
                    1
                ) * 100;

                return (
                    <span 
                        key={star}
                        className="star"
                        style={{
                            "--fill": `${fillPercentage}%`
                        }}
                    >
                        ★
                    </span>
                );
            })}
        </div>
    );
};

export default StarRating;

